import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import {
  ConfigurationProfile,
  configurationProfilesSchema,
} from './schemas/configuration-profile.schema';
import { messageSchema } from './schemas/message-schema';

export function postConfigurationProfiles(
  configurationProfile: Partial<ConfigurationProfile>[]
) {
  return fromFetch(
    new Request(fleetEnvironment.configurationProfilesUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(configurationProfile),
    })
  ).pipe(
    selectData(
      messageSchema.extend({
        data: configurationProfilesSchema,
      })
    )
  );
}
